
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTextIcon as ObiTextIconElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-text-icon.js';
 
 
 

 
 export const ObiTextIcon = createComponent({
   react: React,
   tagName: 'obi-text-icon',
   elementClass: ObiTextIconElement,
   events: {
     
   }
  });
 
 